import imageCard1 from '../assets/images/pages/article-1/main.jpg'
import imageCard2 from '../assets/images/pages/article-2/main.jpg'
// import imageCard3 from '../assets/images/pages/article-3/main.jpg'
// import imageCard4 from '../assets/images/pages/article-4/main.jpg'
import imageCard5 from '../assets/images/pages/article-5/main.jpg'
import imageCard6 from '../assets/images/pages/article-6/main.jpg'
import imageCard7 from '../assets/images/pages/article-7/main.jpg'
// import imageCard8 from '../assets/images/pages/article-8/main.jpg'
// import imageCard9 from '../assets/images/pages/article-9/main.jpg'
import imageCard10 from '../assets/images/pages/article-10/main.jpg'
import imageCard11 from '../assets/images/pages/article-11/main.jpg'
import imageCard12 from '../assets/images/pages/article-12/main.jpg'
import imageCard13 from '../assets/images/pages/article-13/main.jpg'
import imageCard14 from '../assets/images/pages/article-14/main.jpg'
import imageCard15 from '../assets/images/pages/article-15/main.jpg'
import imageCard16 from '../assets/images/pages/article-16/1.jpg'
import imageCard17 from '../assets/images/pages/article-17/1.jpg'
import imageCard18 from '../assets/images/pages/article-18/1.jpg'
import imageCard19 from '../assets/images/pages/article-19/1.jpg'
import imageCard19Speaker from '../assets/images/pages/article-19/speaker.jpg'
import imageCard20 from '../assets/images/pages/article-20/1.jpeg'
import imageCard21 from '../assets/images/pages/article-21/1.jpg'

export type ArticleAuthorType = {
  name: string
  post: string
  // image: string
}

export type ArticleCardType = {
  id: string
  shortName?: string
  name: string
  image: string
  author?: ArticleAuthorType
  onClick?: (id: string) => void
}

export const articleCards: ArticleCardType[] = [
  {
    id: '2',
    name: 'Жизнь в комфортной среде: стоит ли покупать квартиру в готовом квартале',
    image: imageCard2,
  },
  // {
  //   id: '3',
  //   name: 'Город для детей: детство и родительство в современных жилых кварталах',
  //   image: imageCard3,
  // },
  // {
  //   id: '4',
  //   name: 'Удобные планировки: как меняются квартиры и что хотят покупатели',
  //   image: imageCard4,
  // },
  {
    id: '1',
    name: 'Эффект масштаба: что такое жилые кластеры и чем они хороши',
    image: imageCard1,
  },
  {
    id: '5',
    name: 'Одобрить за 24 часа: чем интересна ипотека через сайт застройщика',
    image: imageCard5,
  },
  {
    id: '6',
    name: 'За что именно платят жители современных жилых кварталов?',
    image: imageCard6,
  },
  {
    id: '7',
    name: 'Феномен зеленого двора: как жизнь в окружении природы влияет на горожан',
    image: imageCard7,
  },
  // {
  //   id: '8',
  //   name: 'Чем интересен ретейл в новостройке: тренды, доходность и советы экспертов',
  //   image: imageCard8,
  // },
  // {
  //   id: '9',
  //   name: '5 способов купить квартиру выгоднее',
  //   image: imageCard9,
  // },
  {
    id: '10',
    name: 'Как выбрать квартиру для инвестиций: советы экспертов',
    image: imageCard10,
  },
  {
    id: '11',
    name: 'Тренд на активность: как популярность спорта изменила жилые кварталы',
    image: imageCard11,
  },
  {
    id: '12',
    name: 'Как и почему в России изменился подход к строительству школ',
    image: imageCard12,
  },
  {
    id: '13',
    name: 'Почему новое поколение отказывается от машин и как это влияет на города',
    image: imageCard13,
  },
  // {
  //   id: '14',
  //   name: 'Ипотека с господдержкой закончится 1 июля. Что делать покупателям?',
  //   image: imageCard14,
  // },
  {
    id: '15',
    name: 'Под открытым небом: в чем секрет популярности балконов и террас',
    image: imageCard15,
  },
  {
    id: '16',
    shortName: 'Как меняются дворы в современных кварталах',
    name: 'Парк под окном: как ПИК превращает дворы в места для вдохновения и отдыха',
    image: imageCard16,
    author: {
      name: 'Антон Погорельский',
      post: 'Автор',
      // image: imageCard19Speaker,
    },
  },
  {
    id: '17',
    shortName: 'Большой гид по «Серии плюс»: что важно знать',
    name: 'Большой гид по «Серии плюс»: чем интересны кварталы ПИК нового поколения',
    image: imageCard17,
    author: {
      name: 'Антон Погорельский',
      post: 'Автор',
      // image: imageCard19Speaker,
    },
  },
  {
    id: '18',
    name: 'Найден способ подсчитать, каким может быть спрос на аренду жилья в Москве',
    image: imageCard18,
  },
  {
    id: '19',
    shortName: '5 интересных проектов в Москве и области',
    name: 'Где купить квартиру в 2025 году: 5 интересных проектов в Москве и области',
    image: imageCard19,
    author: {
      name: 'Антон Погорельский',
      post: 'Автор',
      // image: imageCard19Speaker,
    },
  },
  {
    id: '20',
    shortName: 'Территория счастливого детства',
    name: 'Разбираемся, чем современные детские сады отличаются от своих предшественников',
    image: imageCard20,
  },
  {
    id: '21',
    shortName: '5 стратегий инвестора в недвижимость',
    name: '5 стратегий инвестора в недвижимость: как устроены и какую выбрать',
    image: imageCard21,
    author: {
      name: 'Антон Погорельский',
      post: 'Автор',
    },
  },
].reverse()
